import { AddonTypeEnum } from '@vacationtracker/shared/types/addons'
import { FeatureFlagEnum } from '@vacationtracker/shared/types/feature-flags'
import { NUMBER_OF_LOCATIONS_LIMIT, NUMBER_OF_TEAMS_LIMIT } from '@vacationtracker/shared/data/app-parameters'

export interface IAddonStatus {
  type: string
  status: string
}

export interface ICoreLimitsInput {
  teamCount: number
  locationCount: number
  featureFlags: string[]
  addons: IAddonStatus[]
}

export interface ICoreLimitsResult {
  allowUnlimitedTeams: boolean
  allowUnlimitedLocations: boolean
  isOverCoreLimits: boolean
}

// Matches PlanLimitsValidator on the backend, which counts an unlimited add-on in any status
const hasAddon = (addons: IAddonStatus[], type: AddonTypeEnum): boolean => addons.some((addon) => addon.type === type)

export const checkCoreLimits = ({ teamCount, locationCount, featureFlags, addons }: ICoreLimitsInput): ICoreLimitsResult => {
  const allowUnlimitedTeams = featureFlags.includes(FeatureFlagEnum.noLimitTeams) || hasAddon(addons, AddonTypeEnum.NO_LIMIT_TEAMS)
  const allowUnlimitedLocations = featureFlags.includes(FeatureFlagEnum.noLimitLocation) || hasAddon(addons, AddonTypeEnum.NO_LIMIT_LOCATION)
  return {
    allowUnlimitedTeams,
    allowUnlimitedLocations,
    isOverCoreLimits: (!allowUnlimitedTeams && teamCount > NUMBER_OF_TEAMS_LIMIT) || (!allowUnlimitedLocations && locationCount > NUMBER_OF_LOCATIONS_LIMIT),
  }
}
